<template>
  <div class="detailBox" style="position: relative">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        :rules="rules"
        inline
      >
        <ul style="display: flex">
          <el-form-item
            label="状态"
            prop="IsQy"
            :rules="[
              { required: true, message: '请选择角色状态', trigger: 'blur' },
            ]"
            style="flex: 1"
          >
            <el-switch v-model="state.model.IsQy" />
          </el-form-item>
          <el-form-item
            label="客户经理"
            prop="JlId"
            :rules="[
              { required: true, message: '请选择客户经理', trigger: 'blur' },
            ]"
            style="flex: 1"
          >
            <div style="display: flex; width: 100%; overflow: hidden">
              <el-input
                v-model="state.item.JlXm"
                class="shade"
                style="margin-right: 10px"
                readonly
              ></el-input>
              <el-button type="warning" @click="state.showUser = true">
                选择
              </el-button>
            </div>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item
            label="姓名"
            prop="Mc"
            :rules="[
              { required: true, message: '请输入客户姓名', trigger: 'blur' },
            ]"
            style="flex: 1"
          >
            <el-input v-model="state.model.Mc"></el-input>
          </el-form-item>
          <el-form-item label="性别" style="flex: 1">
            <el-radio-group v-model="state.model.Xb">
              <el-radio :label="1" style="color: #1779de"> 男 </el-radio>
              <el-radio :label="2" style="color: #f00"> 女 </el-radio>
            </el-radio-group>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item
            label="手机号码"
            prop="Sjhm"
            :rules="[
              { required: true, message: '请输入手机号码', trigger: 'blur' },
            ]"
            style="flex: 1"
          >
            <el-input v-model="state.model.Sjhm"></el-input>
          </el-form-item>
          <el-form-item label="出生日期" style="flex: 1">
            <el-date-picker
              v-model="state.model.Sr"
              type="date"
              placeholder="--出生日期--"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              :disabled-date="
                (data) => {
                  return $dayjs(data) > $dayjs();
                }
              "
            />
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="来源" style="flex: 1">
            <el-select v-model="state.model.Ly" :clearable="false">
              <el-option label="网络" :value="1" />
              <el-option label="现场" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="职务" style="flex: 1">
            <el-input v-model="state.model.Zw"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="QQ账号" style="flex: 1">
            <el-input v-model="state.model.Qq"></el-input>
          </el-form-item>
          <el-form-item label="微信账号" style="flex: 1">
            <el-input v-model="state.model.Wxh"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="微博账号" style="flex: 1">
            <el-input v-model="state.model.Wb"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" style="flex: 1">
            <el-input v-model="state.model.Yx"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="现住地址" style="flex: 1">
            <el-input v-model="state.model.Dz"></el-input>
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="备注说明" style="flex: 1">
            <el-input
              type="textarea"
              v-model="state.model.Bz"
              :autosize="{ minRows: 4 }"
            />
          </el-form-item>
        </ul>
        <ul style="display: flex">
          <el-form-item label="是否分佣" style="flex: 1">
            <el-switch v-model="state.model.IsFenyong" />
          </el-form-item>
        </ul>
        <!-- 分佣相关信息 -->
        <div
          v-if="state.model.IsFenyong"
          style="
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            padding: 20px;
            margin: 10px 0;
          "
        >
          <h3 style="margin-top: 0; margin-bottom: 20px; color: #606266">
            分佣信息
          </h3>
          <ul style="display: flex">
            <el-form-item
              label="银行账户名"
              prop="Jszhm"
              :rules="[
                {
                  required: state.model.IsFenyong,
                  message: '请输入结算账户名',
                  trigger: 'blur',
                },
              ]"
              style="flex: 1"
            >
              <el-input v-model="state.model.Jszhm"></el-input>
            </el-form-item>
            <el-form-item
              label="银行卡号"
              prop="Jsyhkh"
              :rules="[
                {
                  required: state.model.IsFenyong,
                  message: '请输入结算银行卡号',
                  trigger: 'blur',
                },
              ]"
              style="flex: 1"
            >
              <el-input v-model="state.model.Jsyhkh"></el-input>
            </el-form-item>
          </ul>
          <ul style="display: flex">
            <el-form-item
              label="银行所在省"
              prop="YhsZsCode"
              style="flex: 1"
              :rules="[
                {
                  required: state.model.IsFenyong,
                  message: '请选择银行所在省',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="state.model.YhsZsCode"
                @change="onProvinceChange"
                placeholder="请选择省份"
              >
                <el-option
                  v-for="province in state.provinces"
                  :key="province.code"
                  :label="province.name"
                  :value="province.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="银行所在市"
              prop="YhsCsCode"
              style="flex: 1"
              :rules="[
                {
                  required: state.model.IsFenyong,
                  message: '请选择银行所在市',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="state.model.YhsCsCode"
                @change="onCityChange"
                placeholder="请先选择省份"
                :disabled="!state.model.YhsZsCode"
              >
                <el-option
                  v-for="city in state.cities"
                  :key="city.code"
                  :label="city.name"
                  :value="city.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </ul>
          <ul style="display: flex">
            <el-form-item
              label="证件号码"
              prop="Zjh"
              :rules="[
                {
                  required: state.model.IsFenyong,
                  message: '请输入证件号码',
                  trigger: 'blur',
                },
              ]"
              style="flex: 1"
            >
              <el-input v-model="state.model.Zjh"></el-input>
            </el-form-item>
            <el-form-item label="结算周期" style="flex: 1">
              <el-select v-model="state.model.Jszq">
                <el-option label="D1：下个自然日到账" value="D1" />
                <el-option label="T1：下个工作日到账" value="T1" />
                <el-option label="TS:笔笔结算" value="TS" />
              </el-select>
            </el-form-item>
          </ul>
          <ul style="display: flex">
            <el-form-item
              label="证件有效期"
              style="flex: 1"
              :rules="[
                {
                  validator: (rule, value, callback) => {
                    if (state.model.IsFenyong) {
                      // 如果没有开始日期，返回错误
                      if (!state.model.ZjyxqKs) {
                        callback(new Error('请选择有效期开始日期'));
                      } else if (
                        !state.model.IsZjYxqCq &&
                        !state.model.ZjyxqJz
                      ) {
                        // 如果不是长期有效且没有截止日期，返回错误
                        callback(
                          new Error('请选择有效期截止日期或勾选长期有效')
                        );
                      } else {
                        callback();
                      }
                    } else {
                      callback();
                    }
                  },
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-date-picker
                v-model="state.model.ZjyxqKs"
                type="date"
                placeholder="--有效期开始--"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
              />&nbsp;
              <div style="display: flex; align-items: center">
                <el-date-picker
                  v-model="state.model.ZjyxqJz"
                  type="date"
                  placeholder="--有效期截止--"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  :disabled="state.model.IsZjYxqCq"
                />
                <el-checkbox
                  v-model="state.model.IsZjYxqCq"
                  @change="handleLongTermChange"
                  style="margin-left: 10px"
                  >长期有效</el-checkbox
                >
              </div>
            </el-form-item>
          </ul>
          <ul style="display: flex">
            <el-form-item label="身份证地址" style="flex: 1">
              <el-input v-model="state.model.Sfzdz"></el-input>
            </el-form-item>
          </ul>
        </div>
        <template v-if="props.id">
          <el-form-item label="创建人">
            <el-input v-model="state.model.CjrXm" disabled></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="state.model.Cjsj" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showUser"
        title="选择客户经理"
        @close="state.showUser = false"
      >
        <c_KeHuSelectUser @close="onUserClose" :id="state.model.JlId">
        </c_KeHuSelectUser>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { kehu_add, kehu_detail, kehu_edit, quyu_list } from "@/http/api";
import { ElMessage } from "element-plus";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);

    const state = reactive({
      model: {
        IsQy: true,
        Xb: 1,
        Lx: 1,
        Ly: 1,
        IsFenyong: false,
        Zjh: "",
        ZjyxqKs: "",
        ZjyxqJz: "",
        IsZjYxqCq: false, // 是否长期有效
        Sfzdz: "",
        Jszhm: "",
        Jsyhkh: "",
        YhsZs: "",
        YhsCs: "",
        YhsZsCode: "", // 省份代码
        YhsCsCode: "", // 城市代码
        Jszq: "TS",
      },
      item: {},
      provinces: [], // 省份列表
      cities: [], // 城市列表
      allRegions: [], // 所有区域数据
    });
    // 加载选中省份对应的城市
    const loadCities = (provinceCode) => {
      if (!provinceCode || !state.allRegions.length) {
        state.cities = [];
        state.model.YhsCs = "";
        state.model.YhsCsCode = "";
        return;
      }

      // 提取选中省份对应的所有不重复的城市
      const cityMap = new Map();
      state.allRegions.forEach((region) => {
        if (
          region.FProvinceCode === provinceCode &&
          region.FCity &&
          !cityMap.has(region.FCityCode)
        ) {
          cityMap.set(region.FCityCode, {
            code: region.FCityCode,
            name: region.FCity,
          });
        }
      });
      state.cities = Array.from(cityMap.values());

      // 重置城市选择
      state.model.YhsCs = "";
      state.model.YhsCsCode = "";
    };

    // 处理省份选择变化
    const onProvinceChange = (provinceCode) => {
      if (!provinceCode) {
        state.model.YhsZs = "";
        state.model.YhsCs = "";
        state.model.YhsCsCode = "";
        state.cities = [];
        return;
      }

      // 设置省份名称
      const province = state.provinces.find((p) => p.code === provinceCode);
      if (province) {
        state.model.YhsZs = province.name;
      }

      // 加载对应的城市列表
      loadCities(provinceCode);
    };

    // 处理城市选择变化
    const onCityChange = (cityCode) => {
      if (!cityCode) {
        state.model.YhsCs = "";
        return;
      }

      // 设置城市名称
      const city = state.cities.find((c) => c.code === cityCode);
      if (city) {
        state.model.YhsCs = city.name;
      }
    };

    // 获取区域数据
    const getRegionData = async () => {
      try {
        const res = await quyu_list();
        if (res.status === 200) {
          state.allRegions = res.data || [];
          // 提取所有不重复的省份
          const provinceMap = new Map();
          state.allRegions.forEach((region) => {
            if (region.FProvince && !provinceMap.has(region.FProvinceCode)) {
              provinceMap.set(region.FProvinceCode, {
                code: region.FProvinceCode,
                name: region.FProvince,
              });
            }
          });
          state.provinces = Array.from(provinceMap.values());
        }
      } catch (error) {
        console.error("获取区域数据失败:", error);
      }
    };

    onMounted(async () => {
      // 先获取区域数据
      await getRegionData();

      if (props.id) {
        kehu_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { model, item } = res.data;
            state.model = model;
            // 确保IsZjYxqCq字段存在
            if (state.model.IsZjYxqCq === undefined) {
              state.model.IsZjYxqCq = false;
            }
            if (!state.model.Jszq) {
              state.model.Jszq = "TS";
            }
            state.item = item;

            // 如果有已保存的省份信息，设置省份代码并加载对应城市
            if (
              (state.model.YhsZs || state.model.YhsZsCode) &&
              state.allRegions.length > 0
            ) {
              let provinceCode = state.model.YhsZsCode;
              const savedCityCode = state.model.YhsCsCode;
              const savedCityName = state.model.YhsCs;

              // 如果有省份名称但没有省份代码，根据名称查找代码
              if (!provinceCode && state.model.YhsZs) {
                const province = state.provinces.find(
                  (p) => p.name === state.model.YhsZs
                );
                if (province) {
                  provinceCode = province.code;
                  state.model.YhsZsCode = province.code;
                }
              }

              // 如果有省份代码，加载对应城市
              if (provinceCode) {
                // 加载对应城市
                loadCities(provinceCode);
                // 设置城市代码和名称
                if (savedCityCode) {
                  // 优先根据保存的城市代码查找
                  const city = state.cities.find(
                    (c) => c.code === savedCityCode
                  );
                  if (city) {
                    state.model.YhsCsCode = city.code;
                    state.model.YhsCs = city.name;
                  }
                } else if (savedCityName) {
                  // 如果没有城市代码，根据保存的城市名称查找
                  const city = state.cities.find(
                    (c) => c.name === savedCityName
                  );
                  if (city) {
                    state.model.YhsCsCode = city.code;
                    state.model.YhsCs = city.name;
                  }
                }
              }
            }
          }
        });
      }
    });

    const onUserClose = (row) => {
      state.model.JlId = row.Id;
      state.item.JlXm = row.Xm;
      state.showUser = false;
    };

    // 处理长期有效选择变化
    const handleLongTermChange = (checked) => {
      if (checked) {
        state.model.ZjyxqJz = ""; // 选择长期有效时清空截止日期
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          // 创建提交数据的副本，避免修改原始数据
          const submitData = { ...state.model };

          // 如果选择了长期有效，可以根据业务需求设置一个特殊值或保持为空
          if (submitData.IsZjYxqCq) {
            submitData.ZjyxqJz = ""; // 或设置为特定值如'9999-12-31'
          }

          if (props.id) {
            kehu_edit(props.id, submitData).then((res) => {
              if (res.status == 200) {
                ElMessage.success(res.data);
                setTimeout(() => {
                  emit("close");
                }, 500);
              }
            });
          } else {
            kehu_add(submitData).then((res) => {
              if (res.status == 200) {
                ElMessage.success("添加成功");
                setTimeout(() => {
                  emit("close");
                }, 500);
              }
            });
          }
        }
      });
    };

    return {
      state,
      onSubmit,
      props,
      formDom,
      onUserClose,
      onProvinceChange,
      onCityChange,
      handleLongTermChange,
    };
  },
};
</script>
<style scoped></style>
